// Module
var code = "<div class=\"flex flex-col h-full justify-between assistant-template\"> </div>";
// Exports
export default code;